import React from "react";
import TopBar from "../components/menu/TopBar";
import AppintakeCard from "../components/appintake/AppintakeCard";
import ReactWizard from "../components/wizard/ReactWizard";
import PersonalInfo from "../components/appintake/PersonalInfo";
import Medical from "../components/appintake/Medical";
import AuthorizedPerson from "../components/appintake/AuthorizedPerson";
import Insurance from "../components/appintake/Insurance";
import Authorization from "../components/appintake/Authorization";
import { language } from "../stores/slices/languageSlice";
import { useSelector } from "react-redux";
import PatientMedical from '../components/appintake/PatientMedical';

function AppIntake() {

    const selectedLanguage = useSelector(language).Wizard;
    const appIntakeSteps = useSelector(state => state.preQualValidateSlice.success.appIntakeSteps)

    const Tabs = []
    appIntakeSteps.personalInfo && Tabs.push({ label: selectedLanguage.appintake.personalInfo, component: <PersonalInfo />, isSubTab: false })
    appIntakeSteps.authorizedPerson && Tabs.push({ label: selectedLanguage.appintake.authorizePerson, component: <AuthorizedPerson />, isSubTab: false })
    appIntakeSteps.insurance && Tabs.push({ label: selectedLanguage.appintake.insurance, component: <Insurance />, isSubTab: false })
    appIntakeSteps.treatment && Tabs.push({ label: selectedLanguage.appintake.medical, component: <PatientMedical />, isSubTab: false })
    appIntakeSteps.authorization && Tabs.push({ label: selectedLanguage.appintake.authorization, component: <Authorization />, isSubTab: false })

    return (
        <div className="content check">
            <TopBar />
            <AppintakeCard  flow={{flow:'Application'}}/>
            <div className="intro-y box mt-5 d-flex justify-content-center">
                <ReactWizard Tabs={Tabs} finishButtonText={"Submit"} />
            </div>
        </div>
    );
}

export default AppIntake;
